import React from 'react';
import { ShieldAlert } from 'lucide-react';
import StagePage from './StagePage';
import { Skeleton } from './StageUi';

// AUTO-CRM-32: shared waiting and no-access states for protected pages.
export function StageConnecting() {
  return (
    <StagePage>
      <div className="crm-connecting" role="status" aria-label="Connecting to Auto Appy">
        <Skeleton width={180} height={11} />
        <Skeleton width={320} height={32} radius={12} />
        <Skeleton height={88} radius={20} style={{ marginTop: 8 }} />
        <Skeleton height={260} radius={20} />
        <span className="ws-sr-only">Connecting to Auto Appy…</span>
      </div>
    </StagePage>
  );
}

export function StageNoAccess({ children = 'Your Auto Appy account does not have access to Auto Appy CRM.' }) {
  return (
    <StagePage>
      <section className="ws-card ws-card-pad crm-no-access" role="alert">
        <span className="ws-icon-tile ws-icon-tile--red" aria-hidden="true"><ShieldAlert size={18} /></span>
        <div>
          <h1 className="ws-h2">No access to the CRM</h1>
          <p className="ws-muted" style={{ marginTop: 4 }}>{children} Ask an owner or admin of your organisation to turn on CRM for you.</p>
        </div>
      </section>
    </StagePage>
  );
}
